module.exports = __webpack_public_path__ + "static/paper_icon-fe14682344a72c5c25ff54d0734fc609.svg";